export default {
  stats: {
    table: {
      rank: "Ranking",
      name: "Nome",
    },
    legend: {
      title: "Legenda",
    },
    filters: {
      titles: {
        week: "Semana",
        round: "Rodada",
        split: "Divisão",
      },
      options: {
        all: "Todas",
        qualifier: {
          cumulativeStats: "Total",
          perGame: "Por jogo",
        },
      },
    },
  },
};
